function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { colors } from '@guryou/colors';
import { borderDefinition, boxShadowLight, sizes, smallBorderRadius, spacer } from '@guryou/html-theme';
import { AppBar, Toolbar } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import propsToCss, { toPixel } from '../utils/propsToCss';
const Block = styled.div`
  overflow-y: hidden;
  margin: 0 auto;
  ${props => propsToCss(props)};
`;
const PaperBlock = styled.div`
  background-color: ${colors.white};
  padding: 20px;
  box-shadow: ${boxShadowLight};
  border-radius: ${smallBorderRadius};
  border: ${borderDefinition()};
  margin: 0 auto;
  ${props => propsToCss(props)};
`;
const FlexColumn = styled(Block)`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({
  hover,
  hoverEffect
}) => hover && `&:hover {
    ${Object.keys(hoverEffect).map(x => `${x}: ${hoverEffect[x]};`).join('')}
  }`}
`;
const FlexRow = styled(Block)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: unset;
`;
const GyAppBar = ({
  children,
  minHeight,
  height,
  marginTop,
  ...props
}) => {
  const styles = {
    minHeight: toPixel(minHeight),
    height: toPixel(height),
    marginTop
  };
  return /*#__PURE__*/React.createElement(AppBar, _extends({
    style: styles
  }, props), children);
};
const GyToolbar = ({
  children,
  minHeight,
  justifyContent,
  ...props
}) => {
  const styles = {
    minHeight: toPixel(minHeight),
    justifyContent
  };
  return /*#__PURE__*/React.createElement(Toolbar, _extends({
    style: styles
  }, props), children);
};

// Obsolete
const CenterMediumContent = styled.div`
  width: ${sizes.medium}px;
  padding: ${({
  isMobile
}) => isMobile ? '0' : `${spacer.spacer2}px`}
  margin: ${spacer.spacer3}px auto;
  margin-top: ${props => `${(props.isPublicContent ? -150 : 0) + spacer.spacer3}px`};
`;

// One size scale for the group-color swatch everywhere it appears (Configuration >
// Groups, Customers, Catalogue, print exports, ...) instead of every call site picking
// its own literal pixel string — that's how the same swatch ended up rendering at
// four different sizes (10px default, 14px, 20-25px in PDFs, 35px on most list pages).
// `size` sets the default; an explicit width/height prop still overrides it via
// propsToCss, kept for backward compatibility.
const LITTLE_CIRCLE_SIZES = {
  sm: 14,
  md: 20,
  lg: 28
};
const LittleCircle = styled.div`
  width: ${props => `${LITTLE_CIRCLE_SIZES[props.size] || LITTLE_CIRCLE_SIZES.md}px`};
  height: ${props => `${LITTLE_CIRCLE_SIZES[props.size] || LITTLE_CIRCLE_SIZES.md}px`};
  border-radius: 50px;
  background: '#fff';
  border: '1px solid #000';
  flex-shrink: 0;
  ${props => propsToCss(props)};
`;
const VerticalLine = styled.div`
  width: 1px;
  background: #252525;
  ${props => propsToCss(props)};
`;
Block.propTypes = {
  margin: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  hover: PropTypes.object
};
Block.defaultProps = {
  padding: 0,
  margin: 1,
  xs: 12
};
FlexRow.defaultProps = {
  padding: 0,
  margin: 1,
  xs: 12
};
export { GyAppBar as AppBar, Block, CenterMediumContent, FlexColumn, FlexRow, LittleCircle, PaperBlock, GyToolbar as Toolbar, VerticalLine };